import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    LeftSide,
    ChevronRight,
    DragGameIcon,
    GameName,
    GameRowCategory,
    ImagePlaceholder,
    ImageWrapper,
    RightSideCategory,
    SupplierName,
    ChevronIconWrapper,
    GameImageWrapperLazy,
} from './GameRow.style';
import { GameType } from 'src/domains/casino/models/models';
import { StatusLabel } from 'src/domains/layouts/shared/labels/StatusLabel';
import { casinoProviderUtils } from 'src/domains/casino/utils/CasinoProviderUtils';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

class ClickHandler {
    private static maxClickTime: number = 250;
    private static clickTimestamp: number = 0;
    private static gameKey: string | null = null;

    public static clickStart = (key: string) => (): void => {
        ClickHandler.gameKey = key;
        ClickHandler.clickTimestamp = new Date().getTime();
    };

    public static clickEnd = (key: string, callback: () => void) => (): void => {
        if (key === ClickHandler.gameKey) {
            const endTime = new Date().getTime();
            if (endTime - ClickHandler.clickTimestamp < ClickHandler.maxClickTime) {
                callback();
            }
        }
        ClickHandler.clickTimestamp = 0;
        ClickHandler.gameKey = null;
    };
}
interface GameRowPropsType {
    gameModel: GameType;
    isDragged: boolean;
    handleClick: (id: number) => void;
}

export const GameRow = observer('GameRow', (props: GameRowPropsType) => {
    const { gameModel, isDragged, handleClick } = props;
    const common = useCommon();
    const { casinoStoreEnabled } = ConfigState.get(common).config;
    const displayStudio =
        gameModel.studio_name !== '' && gameModel.studio_name.toLowerCase() !== gameModel.provider.toLowerCase();
    const providerName = casinoStoreEnabled
        ? casinoProviderUtils.convertSlugToName(gameModel.provider)
        : gameModel.provider;
    const onClickGame = (): void => {
        handleClick(gameModel.id);
    };

    return (
        <GameRowCategory
            isDragged={isDragged}
            onMouseDown={ClickHandler.clickStart(gameModel.id.toString())}
            onMouseUp={ClickHandler.clickEnd(gameModel.id.toString(), onClickGame)}
        >
            <DragGameIcon />
            <LeftSide>
                <ImageWrapper>
                    {gameModel.image === '' ? (
                        <ImagePlaceholder>No image</ImagePlaceholder>
                    ) : (
                        <GameImageWrapperLazy
                            imgSrc={gameModel.image}
                            alt={gameModel.name}
                        />
                    )}
                </ImageWrapper>
                <GameName>{gameModel.name}</GameName>
            </LeftSide>

            <RightSideCategory>
                <SupplierName>
                    {providerName}
                    {displayStudio ? ` | ${gameModel.studio_name}` : null}
                </SupplierName>
                <StatusLabel status={gameModel.published ? 'live' : 'ended'}>
                    {gameModel.published ? 'Published' : 'Not published'}
                </StatusLabel>
            </RightSideCategory>
            <ChevronIconWrapper>
                <ChevronRight position='right' />
            </ChevronIconWrapper>
        </GameRowCategory>
    );
});
